module.exports = __webpack_public_path__ + "static/media/neweggicon.48035e94.svg";